import { NOTIFICATION_DURATION } from '@/js/constants/index.js';
import { SET_REQUEST, REMOVE_REQUEST } from '@/store/mutations.js';
import app from '@/js/app.js';
import apiRequest from '@/js/helpers/apiRequest.js';

export default {
  state: {
    requests: []
  },

  mutations: {
    [SET_REQUEST]: (state, requests) => {
      if (Array.isArray(requests)) {
        state.requests = Array.from(new Set([...requests, ...state.requests]));
        return;
      }

      state.requests = Array.from(new Set([requests, ...state.requests]));
    },

    [REMOVE_REQUEST]: (state, { id }) => {
      state.requests = state.requests.filter(request => request.id !== id);
    }
  },

  actions: {
    getRequests: async ({ commit }) => {
      try {
        const res = await apiRequest('requests', 'GET', null, true);

        if (res.error) {
          app.$f7.toast
            .create({
              position: 'bottom',
              destroyOnClose: true,
              closeTimeout: NOTIFICATION_DURATION,
              text: res.error
            })
            .open();

          return;
        }

        const requests = await res.success.map(({ id, language_id, level_id, start, user }) => ({
          id,
          languageId: language_id,
          levelId: level_id,
          start,
          user
        }));

        commit(SET_REQUEST, await requests);
      } catch (err) {
        app.$f7.toast
          .create({
            position: 'bottom',
            destroyOnClose: true,
            closeTimeout: NOTIFICATION_DURATION,
            text: 'Failed to load data'
          })
          .open();
        console.error(err);
      }
    },

    acceptRequest: async ({ commit, rootState }, { id: requestId }) => {
      try {
        const res = await apiRequest(`request/accept/${requestId}`, 'POST', null, true);

        if (res.error) {
          app.$f7.toast
            .create({
              position: 'bottom',
              destroyOnClose: true,
              closeTimeout: NOTIFICATION_DURATION,
              text: res.error
            })
            .open();

          return;
        }

        const {
          lesson: { id, start, video, messages },
          user
        } = res.success;

        const lesson = {
          id,
          start,
          video,
          user,
          messages:
            messages && messages.length
              ? messages.map(({ id, created_at, user_id, text }) => ({
                  id,
                  type: user_id === rootState.user.info.id ? 'sent' : 'received',
                  date: created_at,
                  userId: user_id,
                  text
                }))
              : []
        };

        commit('lesson/SET_LESSON', { lesson }, { root: true });
        return lesson.id;
      } catch (error) {
        app.$f7.toast
          .create({
            position: 'bottom',
            destroyOnClose: true,
            closeTimeout: NOTIFICATION_DURATION,
            text: 'Failed to load data'
          })
          .open();
        console.error(error);
      }
    }
  }
};
